import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get Categories List
export const getCategoriesList = createAsyncThunk(
  "getCategoriesList",
  async ({ search, limit }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `categories?search=${search}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Categories List
export const getCategoryList = createAsyncThunk(
  "getCategoriesList",
  async (
    { search, pageLimit, pageCount, sort_by, sort_direction, limit },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `categories?search=${search}&page=${pageCount}&limit=${pageLimit}&sort_by=${sort_by}&sort_direction=${sort_direction}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Categories
export const getCategories = createAsyncThunk(
  "getCategories",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`/categories/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Create Edit Categories
export const createCategories = createAsyncThunk(
  "createCategories",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`categories`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// update Categories Status
export const updateCategoriesStatus = createAsyncThunk(
  "updateCategoriesStatus",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`categories/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete Categories
export const deleteCategories = createAsyncThunk(
  "deleteCategories",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`/categories/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // get Categories List
      .addCase(getCategoriesList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCategoriesList.fulfilled, (state, action) => {
        state.loading = false;
        state.getCategoriesListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getCategoriesList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get Categories
      .addCase(getCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.getCategoriesStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getCategories.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Create Edit categories
      .addCase(createCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.createCategoriesStatus.data = action.payload;
        state.error = false;
      })
      .addCase(createCategories.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // update Categories Status
      .addCase(updateCategoriesStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCategoriesStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.updateCategoriesStatusStatus.data = action.payload;
        state.error = false;
      })
      .addCase(updateCategoriesStatus.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Delete Categories
      .addCase(deleteCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteCategoriesStatus.data = action.payload;
        state.error = false;
      })
      .addCase(deleteCategories.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = categoriesSlice;
export default reducer;
